import { useEffect } from "react";
// Imports directos (no los barrels) para no crear ciclos hooks <-> services/utils.
import { API_URL } from "../../services/services.props";
import { buildQueryString, toISODateFromDMY } from "../../utils/Helpers";
import type {
  DashboardScope,
  DashboardSummaryProps,
} from "../../utils/dashboardMetrics";
import type { DateRangeProps } from "../../components/operations/area";
import { useApiFetch } from "../useApiFetch";

const EMPTY_SUMMARY: DashboardSummaryProps = {
  totals: { sales: 0, redemptions: 0 },
  daily: [],
  top: [],
  topTotal: 0,
};

// Resumen agregado del Inicio (GET /dashboard) para un ámbito y un rango de fechas
// DD/MM/YYYY. Se vuelve a pedir al cambiar el rango.
export const useDashboardSummary = (
  scope: DashboardScope,
  dateRange: DateRangeProps,
  enabled: boolean = true
) => {
  const [fetchSummary, summary, loading] =
    useApiFetch<DashboardSummaryProps>(EMPTY_SUMMARY);

  useEffect(() => {
    if (!enabled) return;
    const query = buildQueryString({
      scope,
      dateFrom: toISODateFromDMY(dateRange.startDate),
      dateTo: toISODateFromDMY(dateRange.endDate),
    });
    fetchSummary(API_URL.DASHBOARD(query), { method: "GET" });
  }, [scope, dateRange.startDate, dateRange.endDate, enabled]);

  return { summary: summary ?? EMPTY_SUMMARY, loading };
};
